import instance from 'utils/axios/instance.axios';
import { PREQUALIFICATION_REVIEW } from './_constant';

export const create = (data = {}) => instance.post(PREQUALIFICATION_REVIEW.CREATE, data);

export const update = (data = {}) => instance.patch(PREQUALIFICATION_REVIEW.UPDATE, data);

export const submit = (data = {}) => instance.patch(PREQUALIFICATION_REVIEW.SUBMIT, data);

export const getDetail = (councilMemberId, councilId, projectProposalId) =>
  instance.get(PREQUALIFICATION_REVIEW.GET_DETAIL, {
    params: { councilMemberId, councilId, projectProposalId },
  });

export const getGeneralProjectProposalInfo = (councilId, projectProposalId) =>
  instance.get(PREQUALIFICATION_REVIEW.GET_PROJECT_PROPOSAL_INFO, {
    params: { councilId, projectProposalId },
  });

export const getReviewerInfo = (councilId, projectProposalId) =>
  instance.get(PREQUALIFICATION_REVIEW.GET_REVIEWER_INFO, {
    params: { councilId, projectProposalId },
  });

export const getDetailFile = (councilMemberId, councilId, projectProposalId) =>
  instance.get(PREQUALIFICATION_REVIEW.GET_DETAIL_FILE, {
    params: { councilMemberId, councilId, projectProposalId },
  });

export const downloadFile = (body = {}) =>
  instance.post(PREQUALIFICATION_REVIEW.DOWNLOAD_FILE, body, { responseType: 'blob' });

export const downloadPdfFile = ({ projectProposalId, councilId, councilMemberId }) =>
  instance.get(PREQUALIFICATION_REVIEW.DOWNLOAD_PDF_FILE, {
    params: {
      projectProposalId,
      councilId,
      councilMemberId,
    },
    responseType: 'blob',
  });

export const downloadPdfTemplate = ({ projectProposalId, councilId, councilMemberId }) =>
  instance.get(PREQUALIFICATION_REVIEW.DOWNLOAD_PDF_TEMPLATE, {
    params: {
      projectProposalId,
      councilId,
      councilMemberId,
    },
    responseType: 'blob',
  });

export const downloadDocxFile = ({ projectProposalId, councilId, councilMemberId }) =>
  instance.get(PREQUALIFICATION_REVIEW.DOWNLOAD_DOCX_FILE, {
    params: {
      projectProposalId,
      councilId,
      councilMemberId,
    },
    responseType: 'blob',
  });

export const downloadDocxTemplate = ({ projectProposalId, councilId, councilMemberId }) =>
  instance.get(PREQUALIFICATION_REVIEW.DOWNLOAD_DOCX_TEMPLATE, {
    params: {
      projectProposalId,
      councilId,
      councilMemberId,
    },
    responseType: 'blob',
  });
